<template>
  <div id="loginReq" class="request-login-overlay">
    <div class="c-box-regist c-request-login mb-24">
      <p>{{ title }}本機能のご利用にはログインが必要です</p>
      <router-link :to="'/account/login?from-page='+getFromPage()" class="c-btn c-btn--red c-btn-require c-btn-require--red box-center mb-8">
        ログインはこちら
      </router-link>
      <div class="c-btn c-btn--red c-btn--grey c-btn-require box-center" id="cancel-login">
        キャンセル
      </div>
    </div>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";

export default Vue.extend({
  name: 'modal_login_required',
  props: ['title'],
  components: {
  },
  methods: {
    getFromPage() {
      return this.$route.path;
    }
  }
})
</script>